/**
 * Bidstream utility functions
 */

export const origin =
  window != window.top && window.location.ancestorOrigins
    ? window.location.ancestorOrigins[
        window.location.ancestorOrigins.length - 1
      ]
    : String(document.location);

export function createBidstreamMediaSrc(
  zid: number|string,
  friendly: string,
  random: number
): string {
  let url = `https://ads.bidstreamserver.com/servlet/view/banner/javascript/zone?zid=${zid}&friendly=${friendly}&pid=0&fr=60&frlm=1&rmpid=true&random=${random}&encode=1`;
  url += `&origin=${encodeURIComponent(origin)}`;
  const referrer = String(document.location);
  if (referrer) url += `&referrer=${referrer}`;
  return url;
}